/*
 * i18n (Initialization)
 */
import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import { defaultLocale, LocaleEnum, supportedLocales } from "./intl.constants"

type TranslationResources = {
	[key in LocaleEnum]?: Record<string, unknown>
}

export async function initI18n(resources: TranslationResources) {
	const formattedResources = Object.fromEntries(
		Object.entries(resources).map(([locale, translations]) => [
			locale,
			{ translation: translations },
		]),
	)

	await i18n
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			resources: formattedResources,
			fallbackLng: defaultLocale,
			supportedLngs: supportedLocales,
			interpolation: {
				escapeValue: false,
			},
			detection: {
				order: ["localStorage", "navigator"],
				lookupLocalStorage: "i18nextLng",
				caches: ["localStorage"],
			},
		})

	return i18n
}
